
const importScript = (googleTracking, pageTracking) => {
  const script = document.createElement('script');
  script.async = true;
  script.id = googleTracking;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=DC-9858150';
  document.body.appendChild(script);

  const activitesPage = require('tag-manager/trackingActivitesPage.js');

  const script2 = document.createElement('script');
  script2.id = pageTracking;
  script2.text = activitesPage.default;
  document.body.appendChild(script2);
};
export default importScript;



/** WEBPACK FOOTER **
 ** ./src/tagManager.js
 **/